/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, Label, Modal, InputSelect, Pagination, InputCheckbox, CustomLoading, Breadcrumb, SaveIcon } from "../../../Components";

/* 🔗 SERVICE */
import { AlocacaoServices } from "../../../Services/alocacoesServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { changeLoations, changeLoationtypes, changeModal } from "../../../Redux/Actions";
import { useSelector } from "react-redux/es/hooks/useSelector";

/* 📁 ASSETS*/
import { Lupa } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, ListButton, PageTitle, ContainerList, HeaderContainer, 
    InputContainer, FilterInput, ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField, isValidEmail, isValidPhone } from "../../../util/validate";

const ListAlocacoes = () => {
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.allocations.list.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/alocacoes' },
        { text: 'allocations', page: '/adm/alocacoes' }
    ]
    
    const [alocations, setAlocations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [typeValue, setTypeValue] = useState("");
    
    const Services = useRef(new AlocacaoServices());
    const NameField = useRef();
    const TypeField = useRef(null);
    const SiglaField = useRef();
    const EmailField = useRef();
    const PhoneField = useRef();
    const AddressField = useRef();
    const CPFField = useRef();
    const IsPersonValue = useRef(false);
    const EntityField = useRef();
    const StateField = useRef();
    const CityField = useRef();
    
    const NameValue = useRef();
    const TypeValue = useRef(null);
    const SiglaValue = useRef();
    const EmailValue = useRef();
    const PhoneValue = useRef();
    const AddressValue = useRef();
    const CPFValue = useRef();
    const EntityValue = useRef();
    const CityValue = useRef();
    
    const searchValue = useRef();
    
    const user = useSelector(state => state.userReducer);
    let active = useSelector(state => state.ModalReducer.name);

    async function getAlocations(){
        let currentalocations = await Services.current.getAllAlocacoes();
        setAlocations(currentalocations);
        setIsLoading(false);
    }

    // Busca alocações do usuário
    async function getLocations(currenttype){
        try {
            let AllLocations = await Services.current.getLocations();
            let LocationsTypes = await Services.current.getLocationsType();
            if(currenttype === 'Entidades'){
                store.dispatch(changeLoations([]));
                store.dispatch(changeLoationtypes(LocationsTypes));
            }else{
                let newtype = currenttype === 'Grupos' ? 'Entidades' : currenttype === 'Unidades' ? 'Grupos' : '';
                store.dispatch(changeLoations(AllLocations[newtype]));
                store.dispatch(changeLoationtypes(LocationsTypes));
            }
        } catch (error) {
            
        }
    }
    
    const getStates = async() => {
        try {
            let States = await Services.current.getStates();
            setStates(States);
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getAlocations();
        if (user?.user?.can?.includes('role.create')) {
            getLocations('Entidades');
            getStates();
        }
    }, []);

    const Locations = useSelector(state => state.UserCurdReducer.Locations);
    const LocationTypes = useSelector(state => state.UserCurdReducer.LocationTypes);

    const Aplyfilter = async() => {
        setIsLoading(true);
        let currentalocations = await Services.current.getAllAlocacoes(searchValue.current);
        setAlocations(currentalocations);
        setIsLoading(false);
    }

    // Salva as edições do usuário
    const Save = async() => {
        store.dispatch(changeModal(''));
        if(isValidField(NameValue) && isValidField(SiglaValue) && isValidField(TypeValue) && isValidField(CityValue.current)){
            let form = new FormData();
            
            if(NameValue.current){form.append('name', NameValue.current)}
            if(SiglaValue.current){form.append('subtitle', SiglaValue.current)}
            if(TypeValue.current){form.append('type', TypeValue.current)}
            if(CityValue.current){form.append('city_code', CityValue.current)}
            if(TypeField.current?.value === '941685e4-0fe4-465e-b976-485443cfbb8e'){
                if(EntityValue.current){form.append('group_id', EntityValue.current)}
            }else if(TypeField.current?.value === '153b08f5-3bac-4614-a325-70f2cc84adc7'){
                if(EntityValue.current){form.append('entity_id', EntityValue.current)}
            }else if(TypeField.current?.value === '6f9d2274-09ed-45d8-96b3-11ee4073da51'){
                if(IsPersonValue.current || IsPersonValue.current === true){  
                    form.append('is_person', true)
                    if(CPFValue.current){form.append('cpf', CPFValue.current)}
                }else{
                    if(CPFValue.current){form.append('cnpj', CPFValue.current)}
                }
                if(EmailValue.current){form.append('email', EmailValue.current)}
                if(PhoneValue.current){form.append('phone', PhoneValue.current)}
                if(AddressValue.current){form.append('address', AddressValue.current)}
            }
            // console.log(form)
            await Services.current.SaveAlocacao(form);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const changepage = async(page) => {
        setIsLoading(true);
        let currentalocations = await Services.current.getAllAlocacoes(searchValue.current, page);
        setAlocations(currentalocations);
        setIsLoading(false);
    }

    const ChangeCities = async(state) => {
        try {
            let Cities = await Services.current.getCities(state);
            setCities(Cities);
        } catch (error) {
            
        }
    }

    return(
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <PageTitle>
                    {t("administrative.sub-items.allocations.list.page-title")}
                </PageTitle>

                <HeaderContainer>
                    <InputContainer>
                        <img src={Lupa} alt={t("inputs.search-allocation.alt")}></img>
                        <FilterInput
                            // onBlur={()=>Aplyfilter()}
                            onKeyDown={(e) => {e.key === 'Enter' && Aplyfilter()}}
                            onChange={(e) => searchValue.current = e.target.value}
                            placeholder={t("inputs.search-allocation.placeholder")}
                        />
                    </InputContainer>
                    <Button width={'fit-content'} text={t("buttons.apply")} color={'white-green'} onClick={() => Aplyfilter()}></Button>
                </HeaderContainer>
                
                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + alocations?.data?.length + " " + t("administrative.sub-items.allocations.list.allocations")} 
                    </CountContainer>
                    {user?.user?.can?.includes('allocation.create') ?
                        <Button onClick={() => {setTypeValue(null); store.dispatch(changeModal('newalocation'))}} width={'fit-content'} color={'gradienteGreen'} icon={''} text={t("buttons.register-allocation")}></Button>
                    :<></>}
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.acronym")}</TitleText>
                        <TitleText>{t("header-table.name")}</TitleText>
                        <TitleText>{t("header-table.type")}</TitleText>
                        <TitleText $align={'center'} width={'100px'}>{t("header-table.actions")}</TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        alocations?.data?.map((item) => (
                            <LineList key={item.id} href={user?.user?.can?.includes('allocation.view') ? `/adm/alocacoes/${item.id}` : undefined}>
                                <ListText>{item.subtitle}</ListText>
                                <ListText>{item.name}</ListText>
                                <ListText>{item.type.name}</ListText>
                                <ListText $align={'center'} width={'100px'}>
                                    <ListButton disabled={true}>...</ListButton>
                                </ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>
                <Pagination last_page={alocations?.meta?.last_page} currentpage={alocations?.meta?.current_page} changepage={changepage}/>
            </Container>
            
            <Modal title={t("modal.register-allocation.title")} name={'newalocation'} width={'70%'} height={'90%'}>
            {active === 'newalocation' ? 
                <>
                    <ContainerRow onSubmit={(e) => e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={t("inputs.name.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='name' 
                                name='name' 
                                type="text" 
                                placeholder={t("inputs.name.placeholder")}
                                innerRef={NameField}
                                invalidMessage={t("inputs.name.invalid-message")}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => NameValue.current = text}> 
                            </Input>

                            {TypeField.current?.value !== '6f9d2274-09ed-45d8-96b3-11ee4073da51' ?
                                <>
                                    <Label text={t("inputs.belongs-to.label")} aling="flex-start"/>
                                    <InputSelect
                                        name={'entity_id'}
                                        id={'entity_id'}
                                        placeholder={t("inputs.belongs-to.placeholder")}
                                        invalidMessage={t("inputs.belongs-to.invalid-message")}
                                        options={Locations}
                                        innerRef={EntityField}
                                        validationFunction={(value) => isValidField(value)}
                                        onchange={(value) => EntityValue.current = value}>
                                    </InputSelect>
                                </>
                            :<>
                                <Label text={t("inputs.cpf/cnpj.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='cpf' 
                                    name='cpf' 
                                    type="text" 
                                    placeholder={t("inputs.cpf/cnpj.placeholder")}
                                    innerRef={CPFField}
                                    invalidMessage={t("inputs.cpf/cnpj.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => CPFValue.current = text}> 
                                </Input>
                                <InputCheckbox text={t("checkbox.natural-person")} onChange={(value) => {IsPersonValue.current = value; return true}}/>
                            </>}
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={t("inputs.acronym.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='sigla' 
                                name='sigla' 
                                type="text" 
                                placeholder={t("inputs.acronym.placeholder")}
                                innerRef={SiglaField}
                                invalidMessage={t("inputs.acronym.invalid-message")}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => SiglaValue.current = text}> 
                            </Input>

                            {TypeField.current?.value === '6f9d2274-09ed-45d8-96b3-11ee4073da51' ?
                                <>
                                    <Label text={t("inputs.email.label")} aling="flex-start"/>
                                    <Input 
                                        aling="flex-start"
                                        id='email' 
                                        name='email' 
                                        type="text" 
                                        placeholder={t("inputs.email.placeholder")}
                                        innerRef={EmailField}
                                        invalidMessage={t("inputs.email.invalid-message")}
                                        validationFunction={(text) => isValidEmail(text)}
                                        onchange={(text) => EmailValue.current = text}> 
                                    </Input>

                                    <Label text={t("inputs.phone.label")} aling="flex-start"/>
                                    <Input 
                                        aling="flex-start"
                                        mask="(99) 99999-9999"
                                        id='telefone' 
                                        name='telefone' 
                                        type="text" 
                                        placeholder={t("inputs.phone.placeholder")}
                                        innerRef={PhoneField}
                                        invalidMessage={t("inputs.phone.invalid-message")}
                                        validationFunction={(text) => isValidPhone(text)}
                                        onchange={(text) => PhoneValue.current = text}> 
                                    </Input>
                                </>
                            :<></>}

                            {TypeField.current?.value === '941685e4-0fe4-465e-b976-485443cfbb8e' ? 
                                <>
                                    <Label text={t("inputs.state.label")} aling="flex-start"/>
                                    <InputSelect
                                        name={'state'}
                                        id={'state'}
                                        placeholder={t("inputs.state.placeholder")}
                                        invalidMessage={t("inputs.state.invalid-message")}
                                        options={states}
                                        innerRef={StateField}
                                        validationFunction={(value) => isValidField(value)}
                                        onchange={(value) => ChangeCities(value)}>
                                    </InputSelect>
                                </>
                            : <></>}

                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={t("inputs.allocation-type.label")} aling="flex-start"/>
                            <InputSelect
                                name={'type'}
                                id={'type'}
                                placeholder={t("inputs.allocation-type.placeholder")}
                                invalidMessage={t("inputs.allocation-type.invalid-message")}
                                options={LocationTypes}
                                innerRef={TypeField}
                                validationFunction={(value) => isValidField(value)}
                                onchange={(value) => {
                                    setTypeValue(value);
                                    TypeValue.current = value;
                                    Services.current.ChangeLocationType(value, EntityField.current);
                                }}>
                            </InputSelect>

                            {TypeField.current?.value === '6f9d2274-09ed-45d8-96b3-11ee4073da51' ?
                                <>
                                    <Label text={t("inputs.address.label")} aling="flex-start"/>
                                    <Input 
                                        aling="flex-start"
                                        id='address' 
                                        name='address' 
                                        type="text" 
                                        placeholder={t("inputs.address.placeholder")}
                                        innerRef={AddressField}
                                        invalidMessage={t("inputs.address.invalid-message")}
                                        validationFunction={(text) => isValidField(text)}
                                        onchange={(text) => AddressValue.current = text}> 
                                    </Input>
                                </>
                            :<></>}

                            {TypeField.current?.value === '941685e4-0fe4-465e-b976-485443cfbb8e' ?
                                <>
                                    <Label text={t("inputs.city.label")} aling="flex-start"/>
                                    <InputSelect
                                        name={'city'}
                                        id={'city'}
                                        placeholder={t("inputs.city.placeholder")}
                                        invalidMessage={t("inputs.city.invalid-message")}
                                        options={cities}
                                        innerRef={CityField}
                                        validationFunction={(value) => isValidField(value)}
                                        onchange={(value) => CityValue.current = value}>
                                    </InputSelect>
                                </>
                            :<></>}

                        </ContainerColumn>
                    </ContainerRow>
                    
                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                        <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={() => store.dispatch(changeModal(''))}/>
                    </ButtonsContainer>
                </>
            :<></>}
            </Modal>
        </>
    )
}

export default ListAlocacoes;